import React, { useState } from "react";
import { NotificationManager } from "react-notifications";

import PaginatedTable from "../../../sharedComponents/tableWithPagination";
import ConfirmDelete from "../../../sharedComponents/confirmDelete";
import NoItems from "../../../sharedComponents/noItemFoundAlert";

const CategoryListing = ({
	title = "",
	getList = null,
	list = [],
	onBack = null,
	deleteItem = null,
	columns = [],
	addForm: AddForm = <span />,
	item = null,
	initialFields = {}
}) => {
	const [selectedItem, setSelectedItem] = useState(null);
	const confirmDelete = (original) => {
		setSelectedItem(original);
	};
	const confirmEvent = (yes) => {
		if (yes) {
			const successHandler = () => {
				NotificationManager.success("Item has been removed!", "", 5000);
			};
			deleteItem && deleteItem(selectedItem.id, successHandler);
			getList && getList();
		}
		setSelectedItem(null);
	};

	const [editItem, setEditItem] = useState(null);
	const editCategoryGroup = (original) => {
		setEditItem(original);
	};

	const categoryGroupColumns = [
		...columns,
		{
			Header: "Actions",
			accessor: "category__id",
			className: "text-right",
			headerClassName: "text-right",
			width: 100,
			Cell: ({ original }) => (
				<div>
					<button
						type="button"
						onClick={() => editCategoryGroup(original)}
						className="btn btn-success btn-ghost btn-sm btn-cell mr-2">
						<i className="icon icon-edit" />
					</button>
					<button
						type="button"
						onClick={() => confirmDelete(original)}
						className="btn btn-danger btn-ghost btn-sm btn-cell">
						<i className="icon icon-trash" />
					</button>
				</div>
			),
			sortable: false
		}
	];

	const onCancel = () => {
		setEditItem(null);
	};

	const onSuccess = (event) => {
		setEditItem(null);
		getList();
		onBack && onBack(event);
	};

	const onAddBtn = () => {
		setEditItem({ ...initialFields });
	};

	return (
		<section className="page page-category-listing">
			<div className="container">
				<div className="anim-panel">
					<div className={`panel ${!editItem ? "active" : ""}`}>
						<div className="row">
							<div className="col-6">
								<button
									className="btn text-primary-dark px-0"
									onClick={() => onBack && onBack({ panel: 1, data: [] })}>
									<i className="icon icon-angle-left" /> Back
								</button>
							</div>
							<div className="col-6 text-right">
								<button className="btn btn-primary-dark" onClick={onAddBtn}>
									{title}
								</button>
							</div>
						</div>
						{list && list.length ? <PaginatedTable columns={categoryGroupColumns} data={list} /> : <NoItems />}
					</div>
					<div className={`panel ${editItem ? "active" : ""}`}>
						<AddForm initialValues={editItem} onCancel={onCancel} onSuccess={onSuccess} item={item} />
					</div>
				</div>
			</div>
			<ConfirmDelete item={selectedItem} message={<div>Are you sure you want to delete?</div>} onEvent={confirmEvent} />
		</section>
	);
};

export default CategoryListing;
